module.exports = __webpack_public_path__ + "img/user-21.e369883e.svg";